import dateFormat from 'dateformat';
import configData from '../config.json';
import { JOB_STATUS } from './constants';

// TODO
export const sortArrayOfObjectsByDate = (array, prop, additionalProp1, additionalProp2) => {
  const sortedArray = array.sort((current, next) =>
    // eslint-disable-next-line no-nested-ternary
    new Date(current[prop]) === new Date(next[prop]) ? 0 : new Date(current[prop]) > new Date(next[prop]) ? -1 : 1
  );

  if (additionalProp1 && additionalProp2) {
    return [
      ...sortArrayOfObjectsByDate(
        array.filter((item) => item[additionalProp1]),
        additionalProp2
      ),
      ...sortedArray.filter((item) => !item[additionalProp1])
    ];
  }
  return sortedArray;
};

export const validatePBData = (data) => {
  const errors = {
    JobExperienceDetails: [],
    EducationDetails: [],
    TrainingDetails: [],
    RequireAtLeastOneItem: []
  };
  data.JobExperienceDetails?.forEach((job) => {
    if (!job.Title || !job.EmployerName || !job.Description || !job.StartDate) errors.JobExperienceDetails.push(job);
  });

  data.EducationDetails?.forEach((edu) => {
    if (!edu.SchoolName || !edu.Degree?.Name || !edu.Major || !edu.StartDate || !edu.EndDate)
      errors.EducationDetails.push(edu);
  });

  data.TrainingDetails?.forEach((training) => {
    if (!training.CertificationType) errors.TrainingDetails.push(training);
  });

  /* Tenporarily comented because of requirements from POs */
  // if (!data?.EducationDetails?.length) {
  //   errors.RequireAtLeastOneItem.push('Education');
  // } else {
  //   errors.RequireAtLeastOneItem = errors.RequireAtLeastOneItem.filter((item) => item !== 'Education');
  // }

  return errors;
};

export const correctData = (obj, dayOffset = 0) => {
  const newObj = { ...obj };
  let startDate = new Date(newObj.StartDate);
  startDate.setDate(startDate.getDate() + dayOffset);
  startDate = dateFormat(startDate, 'isoUtcDateTime');
  let endDate = new Date(newObj.EndDate);
  endDate.setDate(endDate.getDate() + dayOffset);
  endDate = dateFormat(endDate, 'isoUtcDateTime');

  if (newObj.ValidUntil) {
    let validUntil = new Date(newObj.ValidUntil);
    validUntil.setDate(validUntil.getDate() + dayOffset);
    validUntil = dateFormat(validUntil, 'isoUtcDateTime');

    delete newObj.StartDate;
    delete newObj.EndDate;

    return { ...newObj, ValidUntil: validUntil };
  }

  return { ...newObj, StartDate: startDate, EndDate: endDate };
};

// eslint-disable-next-line no-restricted-globals
export const isValidDate = (date) => date instanceof Date && !isNaN(date);

export const increaseDate = (date, numberOfDays) => {
  if (!isValidDate(new Date(date))) return undefined;

  let increasedDate = new Date(date);
  increasedDate.setDate(increasedDate.getDate() + numberOfDays);
  increasedDate = dateFormat(increasedDate, 'isoUtcDateTime');

  return increasedDate;
};

export const withDebounce = (func, delay, timerId, setTimer) => {
  if (timerId) {
    clearTimeout(timerId);
  }
  const timerDelayId = setTimeout(() => {
    setTimer(null);
    func();
  }, delay);
  setTimer(timerDelayId);
};

export const isJobActive = (item) => {
  const currentDate = new Date();
  if (item && item.Job) {
    if (!item.Job.IsActive) {
      return false;
    }
  }

  return true;
};

export const getLastDayOFMounth = (dateString) => {
  const date = new Date(dateString);
  return new Date(date.getFullYear(), date.getMonth() + 1, 0);
};

export const parseAPIErrors = (errors) => {
  return Object.entries(errors).map((error) => {
    const block = error[0].substring(0, error[0].indexOf('['));
    const numberOfEntries = error[0].substring(error[0].indexOf('[') + 1, error[0].indexOf(']'));
    const property = error[0].substring(error[0].indexOf('.') + 1, error[0].length);
    const messages = error[1].join('/');
    return block
      ? `${block} -> Entry number: ${
          Number(numberOfEntries) + 1
        } -> Field: ${property}, has the following errors: ${messages}`
      : `Field: ${property}, has the following errors: ${messages}`;
  });
};

export const getCookie = (name) => {
  const matches = document.cookie.match(
    new RegExp(`(?:^|; )${name?.replace(/([.$?*|{}()[\]\\/+^])/g, '\\$1')}=([^;]*)`)
  );
  return matches ? decodeURIComponent(matches[1]) : undefined;
};

export const checkOnboardingCookie = () => {
  return getCookie(configData.TIFO_ONBOARDING_KEY)
    ? getCookie(configData.TIFO_ONBOARDING_KEY) === configData.TIFO_ONBOARDING_VALUE
    : false;
};

export const removeStyleAttribute = (htmlString) => {
  const regex = /style="[^"]*"/gi;
  return htmlString.replace(regex, '');
};

export const getValuesByKey = (initArray, originalKey, fromArray, byKey) => {
  const uniqArray = Array.from(new Set(initArray.map((item) => item?.[originalKey])));

  if (uniqArray.indexOf(undefined) === 0) {
    return initArray.map((item) => fromArray.find((value) => value?.[byKey] === item));
  }

  return uniqArray.map((item) => fromArray.find((value) => value?.[byKey] === item));
};

export const setClassForStatusBubble = (status, style) => {
  switch (status) {
    case JOB_STATUS.CLOSED:
      return style.grayAppliedTag;
    case JOB_STATUS.APPLIED:
      return style.appliedTag;
    default:
      return style.otherTag;
  }
};

export const createLinkForSharingJob = (ref, id) => `${ref}/jobs/${id}`;
